import { useEffect, useRef } from "react";

export function useWatchPagination(
  pageSize: number,
  pageNum: number,
  fetch: Function
) {
  const mounted = useRef<{ pageSize: number; pageNum: number }>();
  useEffect(() => {
    if (!mounted.current) {
      mounted.current = { pageSize, pageNum };
      return;
    }

    if (
      pageSize !== mounted.current.pageSize ||
      pageNum !== mounted.current.pageNum
    ) {
      mounted.current = { pageSize, pageNum };
      fetch?.();
    }
  }, [pageSize, pageNum, fetch]);
}
